import { FaComments, FaPlus, FaReply, FaUser } from "react-icons/fa";
import { useState } from "react";

export default function MessageBoard() {
  const [threads, setThreads] = useState([
    {
      id: 1,
      title: "Ideas for Staff Appreciation Event",
      author: "Emily Rodriguez",
      date: "2025-01-14",
      category: "Events",
      replies: [
        {
          id: 1,
          author: "Sarah Johnson",
          content: "How about a themed lunch? We could do something fun like a decade theme or tropical theme.",
          date: "2025-01-14",
        },
        {
          id: 2,
          author: "Michael Chen",
          content: "I like that idea! We could also include some team building activities or games.",
          date: "2025-01-15",
        },
        {
          id: 3,
          author: "David Kim",
          content: "What's the budget looking like? That will help us narrow down options.",
          date: "2025-01-15",
        },
      ],
      views: 45,
    },
    {
      id: 2,
      title: "Remote Work Policy Feedback",
      author: "Michael Chen",
      date: "2025-01-13",
      category: "Policy",
      replies: [
        {
          id: 1,
          author: "Lisa Anderson",
          content: "I think the proposed policy is fair. The flexibility will really help with work-life balance.",
          date: "2025-01-13",
        },
        {
          id: 2,
          author: "James Wilson",
          content: "Agreed. One suggestion - can we clarify the expectations around core hours?",
          date: "2025-01-14",
        },
        {
          id: 3,
          author: "Michael Chen",
          content: "Good point James. I'll add that to the revision notes.",
          date: "2025-01-14",
        },
        {
          id: 4,
          author: "Maria Garcia",
          content: "Also, what about equipment/technology support for remote workers?",
          date: "2025-01-15",
        },
      ],
      views: 62,
    },
    {
      id: 3,
      title: "Professional Development Opportunities",
      author: "Sarah Johnson",
      date: "2025-01-12",
      category: "Discussion",
      replies: [
        {
          id: 1,
          author: "David Kim",
          content: "The leadership training program sounds interesting. Has anyone participated before?",
          date: "2025-01-12",
        },
        {
          id: 2,
          author: "Emily Rodriguez",
          content: "I attended last year - highly recommend! Very practical skills.",
          date: "2025-01-13",
        },
      ],
      views: 38,
    },
  ]);

  const [selectedThread, setSelectedThread] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [showNewThreadForm, setShowNewThreadForm] = useState(false);
  const [newThread, setNewThread] = useState({
    title: "",
    category: "General",
    content: "",
    author: "Current User",
  });

  const categories = ["All", "Events", "Policy", "Discussion", "General"];
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredThreads =
    selectedCategory === "All"
      ? threads
      : threads.filter((thread) => thread.category === selectedCategory);

  const addReply = (threadId) => {
    if (!replyText.trim()) return;

    setThreads(
      threads.map((thread) =>
        thread.id === threadId
          ? {
              ...thread,
              replies: [
                ...thread.replies,
                {
                  id: thread.replies.length + 1,
                  author: "Current User",
                  content: replyText,
                  date: new Date().toISOString().split("T")[0],
                },
              ],
            }
          : thread
      )
    );

    setReplyText("");
  };

  const createThread = () => {
    if (!newThread.title.trim() || !newThread.content.trim()) {
      alert("Please fill in both title and content");
      return;
    }

    const threadToAdd = {
      id: threads.length + 1,
      title: newThread.title,
      author: newThread.author,
      date: new Date().toISOString().split("T")[0],
      category: newThread.category,
      replies: [
        {
          id: 1,
          author: newThread.author,
          content: newThread.content,
          date: new Date().toISOString().split("T")[0],
        },
      ],
      views: 0,
    };

    setThreads([threadToAdd, ...threads]);
    setShowNewThreadForm(false);
    setNewThread({
      title: "",
      category: "General",
      content: "",
      author: "Current User",
    });
  };

  const cancelNewThread = () => {
    setShowNewThreadForm(false);
    setNewThread({
      title: "",
      category: "General",
      content: "",
      author: "Current User",
    });
  };

  const ThreadCard = ({ thread }) => (
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e2e8f0",
        marginBottom: "16px",
        cursor: "pointer",
        transition: "all 0.2s",
      }}
      onClick={() => setSelectedThread(thread.id === selectedThread ? null : thread.id)}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          marginBottom: "12px",
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#2d3748",
            margin: 0,
          }}
        >
          {thread.title}
        </h3>
        <span
          style={{
            padding: "4px 10px",
            background: "#f7fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "6px",
            fontSize: "12px",
            color: "#4a5568",
            flexShrink: 0,
            marginLeft: "16px",
          }}
        >
          {thread.category}
        </span>
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          fontSize: "13px",
          color: "#718096",
          marginBottom: selectedThread === thread.id ? "20px" : "0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FaUser style={{ fontSize: "12px" }} />
          {thread.author}
        </div>
        <div>{new Date(thread.date).toLocaleDateString()}</div>
        <div>
          <strong>{thread.replies.length}</strong> replies
        </div>
        <div>
          <strong>{thread.views}</strong> views
        </div>
      </div>

      {/* Expanded Replies */}
      {selectedThread === thread.id && (
        <div
          style={{
            marginTop: "20px",
            paddingTop: "20px",
            borderTop: "2px solid #f7fafc",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {thread.replies.map((reply) => (
            <div
              key={reply.id}
              style={{
                padding: "16px",
                background: "#f7fafc",
                borderRadius: "8px",
                marginBottom: "12px",
                borderLeft: "4px solid #667eea",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#667eea",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "14px",
                    }}
                  >
                    <FaUser />
                  </div>
                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#2d3748",
                        fontSize: "14px",
                      }}
                    >
                      {reply.author}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: "12px", color: "#718096" }}>
                  {new Date(reply.date).toLocaleDateString()}
                </div>
              </div>
              <p
                style={{
                  color: "#4a5568",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  margin: 0,
                  paddingLeft: "40px",
                }}
              >
                {reply.content}
              </p>
            </div>
          ))}

          {/* Reply Form */}
          <div
            style={{
              marginTop: "16px",
              padding: "16px",
              background: "#fafafa",
              borderRadius: "8px",
              border: "2px dashed #e2e8f0",
            }}
          >
            <textarea
              placeholder="Write your reply..."
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "14px",
                minHeight: "80px",
                resize: "vertical",
                marginBottom: "10px",
              }}
            />
            <button
              onClick={() => addReply(thread.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 16px",
                background: "#667eea",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              <FaReply />
              Post Reply
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
            }}
          >
            Message Board
          </h1>
          <p style={{ color: "#718096", fontSize: "16px" }}>
            Discuss topics and collaborate with council members
          </p>
        </div>
        <button
          onClick={() => setShowNewThreadForm(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
          }}
        >
          <FaPlus />
          New Thread
        </button>
      </div>

      {/* New Thread Form */}
      {showNewThreadForm && (
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "32px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            border: "2px solid #667eea",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "24px",
            }}
          >
            Start New Discussion Thread
          </h2>

          {/* Thread Title */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              Thread Title *
            </label>
            <input
              type="text"
              value={newThread.title}
              onChange={(e) => setNewThread({ ...newThread, title: e.target.value })}
              placeholder="Enter discussion topic..."
              style={{
                width: "100%",
                padding: "12px 14px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                fontSize: "15px",
                outline: "none",
              }}
            />
          </div>

          {/* Category Selection */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              Category
            </label>
            <select
              value={newThread.category}
              onChange={(e) => setNewThread({ ...newThread, category: e.target.value })}
              style={{
                width: "100%",
                padding: "12px 14px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                fontSize: "15px",
                outline: "none",
                background: "white",
                cursor: "pointer",
              }}
            >
              {categories.filter(cat => cat !== "All").map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          {/* Initial Message */}
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "8px",
              }}
            >
              Your Message *
            </label>
            <textarea
              value={newThread.content}
              onChange={(e) => setNewThread({ ...newThread, content: e.target.value })}
              placeholder="Start the discussion..."
              rows="6"
              style={{
                width: "100%",
                padding: "12px 14px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                fontSize: "15px",
                resize: "vertical",
                outline: "none",
                lineHeight: "1.6",
              }}
            />
          </div>

          {/* Form Actions */}
          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
            <button
              onClick={cancelNewThread}
              style={{
                padding: "12px 24px",
                background: "#e2e8f0",
                color: "#2d3748",
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={createThread}
              style={{
                padding: "12px 24px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 6px rgba(102, 126, 234, 0.3)",
              }}
            >
              Create Thread
            </button>
          </div>
        </div>
      )}

      {/* Category Filter */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "30px",
          padding: "16px",
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e2e8f0",
          flexWrap: "wrap",
        }}
      >
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            style={{
              padding: "8px 16px",
              background: selectedCategory === category ? "#667eea" : "#f7fafc",
              color: selectedCategory === category ? "white" : "#4a5568",
              border: "1px solid",
              borderColor: selectedCategory === category ? "#667eea" : "#e2e8f0",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: selectedCategory === category ? "600" : "400",
              transition: "all 0.2s",
            }}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#667eea" }}>
            {filteredThreads.length}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Discussion Threads
          </div>
        </div>
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#38a169" }}>
            {filteredThreads.reduce((acc, thread) => acc + thread.replies.length, 0)}
          </div>
          <div style={{ color: "#718096", fontSize: "14px", marginTop: "4px" }}>
            Total Replies
          </div>
        </div>
      </div>

      {/* Threads List */}
      <div>
        {filteredThreads.length > 0 ? (
          filteredThreads.map((thread) => <ThreadCard key={thread.id} thread={thread} />)
        ) : (
          <div
            style={{
              padding: "60px",
              textAlign: "center",
              background: "white",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
            }}
          >
            <FaComments style={{ fontSize: "48px", color: "#cbd5e0", marginBottom: "16px" }} />
            <p style={{ color: "#718096", fontSize: "16px" }}>
              No discussion threads found
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

